import { render, staticRenderFns } from "./MedicinePreview.vue?vue&type=template&id=56d60b2f"
import script from "./MedicinePreview.vue?vue&type=script&lang=js"
export * from "./MedicinePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports